// SidebarContent.jsx

import { Search } from "lucide-react";

export default function SidebarContent({
  search,
  setSearch,
  categoryId,
  setCategoryId,
  categories,
  price,
  setPrice,
  setAppliedPrice,
  setPage,
  clearFilters,
  setMobileFiltersOpen,
}) {
  return (
    <div className="space-y-6">
      {/* SEARCH */}
      <div className="relative">
        <input
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
          placeholder="Search products..."
          className="
            w-full rounded-xl
            border border-gray-200
            bg-white
            px-4 py-2.5 pr-10
            text-sm text-gray-800
            placeholder:text-gray-400
            outline-none
            focus:ring-2 focus:ring-pink-200
          "
        />

        <Search
          size={18}
          className="
            absolute right-3 top-1/2
            -translate-y-1/2
            text-gray-400
          "
        />
      </div>

      {/* CATEGORIES */}
      <div>
        <h4 className="mb-3 text-sm font-semibold text-gray-800">Categories</h4>

        <div className="space-y-2">
          <button
            onClick={() => {
              setCategoryId("");

              setPage(1);

              if (window.innerWidth < 1024) {
                setMobileFiltersOpen(false);
              }
            }}
            className={`
              block text-sm transition
              ${
                !categoryId
                  ? "font-medium text-pink-500"
                  : "text-gray-500 hover:text-gray-800"
              }
            `}
          >
            All
          </button>

          {categories.map((c) => (
            <button
              key={c.id}
              onClick={() => {
                setCategoryId(c.id);

                setPage(1);

                if (window.innerWidth < 1024) {
                  setMobileFiltersOpen(false);
                }
              }}
              className={`
                block text-left text-sm transition
                ${
                  String(categoryId) === String(c.id)
                    ? "font-medium text-pink-500"
                    : "text-gray-500 hover:text-gray-800"
                }
              `}
            >
              {c.name}
            </button>
          ))}
        </div>
      </div>

      {/* PRICE */}
      <div>
        <h4 className="mb-3 text-sm font-semibold text-gray-800">
          Filter By Price
        </h4>

        <input
          type="range"
          min="0"
          max="1000"
          value={price}
          onChange={(e) => {
            setPrice(Number(e.target.value));
          }}
          className="w-full accent-pink-500"
        />

        <p className="mt-2 text-sm text-gray-500">₹0 - ₹{price}</p>

        <button
          onClick={() => {
            setAppliedPrice(price);

            setPage(1);

            if (window.innerWidth < 1024) {
              setMobileFiltersOpen(false);
            }
          }}
          className="
            mt-4 w-full rounded-xl
            bg-pink-500 py-2.5
            text-sm font-medium text-white
            transition hover:bg-pink-600
          "
        >
          Apply Filter
        </button>
      </div>

      {/* CLEAR */}
      <button
        onClick={clearFilters}
        className="
          w-full rounded-xl
          border border-gray-200
          bg-gray-100
          py-2.5
          text-sm font-medium text-gray-700
          transition hover:bg-gray-200
        "
      >
        Clear Filters
      </button>
    </div>
  );
}
